import React from "react";
import { Box, Typography } from "@mui/material";
import moment from "moment";
import { IMAGE_URL } from "src/network/endpoints";

const OrderMessage = ({ message, theme, onViewOrder }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        minWidth: "280px",
        maxWidth: "380px",
        gap: message?.orderId?.status == "draft" ? 1.5 : 0,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-start",
          gap: 2.5,
          padding: "2px 0",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            width: 80,
            height: 80,
            borderRadius: 1.5,
            backgroundColor: "#f3f4f6",
            border: "1px solid #e5e7eb",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
            overflow: "hidden",
          }}
        >
          {message?.orderId?.imageVideo &&
          Array.isArray(message.orderId.imageVideo) &&
          message.orderId.imageVideo.length > 0 ? (
            <img
              src={`${message.orderId.imageVideo[0]}`}
              alt="order item"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          ) : (
            <Typography
              variant="caption"
              sx={{
                color: "#6b7280",
                fontSize: "11px",
                textAlign: "center",
                fontWeight: 500,
              }}
            >
              image placeholder
            </Typography>
          )}
        </Box>

        <Box
          sx={{
            flex: 1,
            minWidth: 0,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            height: "80px",
            overflow: "hidden",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              mb: 0.3,
              minHeight: "20px",
            }}
          >
            <Typography
              variant="h6"
              sx={{
                fontSize: "14px",
                fontWeight: 600,
                color: "#000000",
                textTransform: "lowercase",
                lineHeight: 1.2,
                flex: 1,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              Order #
              {message?.orderId?.orderNumber ||
                message?.orderId?._id?.slice(-8) ||
                "00238521"}
            </Typography>

            <Typography
              variant="caption"
              sx={{
                fontSize: "11px",
                color: "#6b7280",
                fontWeight: 500,
                flexShrink: 0,
                ml: 1,
              }}
            >
              {message?.orderId?.createdAt
                ? moment(message.orderId.createdAt).fromNow()
                : moment(message?.createdAt).fromNow()}
            </Typography>
          </Box>

          <Typography
            variant="body2"
            sx={{
              fontSize: "14px",
              color: "#000000",
              mb: 0.2,
              fontWeight: 500,
            }}
          >
            <span style={{ color: "#7C3AED", fontWeight: 700 }}>
              {message?.orderId?.groupTotalItems}
            </span>
            : items
          </Typography>

          <Box sx={{ mb: 0.2, flex: 1 }}>
            <Typography
              variant="body2"
              sx={{
                fontSize: "12px",
                color: "#6b7280",
                mb: 0.2,
                textTransform: "lowercase",
                fontWeight: 500,
              }}
            >
              {message?.orderId?.orderMode === "seat_down"
                ? "sit down"
                : message?.orderId?.orderMode === "collect"
                ? "collect"
                : "sit down"}
            </Typography>

            <Typography
              variant="body2"
              sx={{
                fontSize: "12px",
                color:
                  message?.orderId?.status == "draft" ? "#FFFFFF" : "#6b7280",
                textDecoration: "underline",
                cursor: "pointer",
                textTransform: "lowercase",
                fontWeight: 500,
              }}
              onClick={() => onViewOrder?.(message)}
            >
              {message?.orderId?.status == "draft" ? "view cart" : "view order"}
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "flex-end",
              mt: "auto",
              minHeight: "20px",
            }}
          >
            <Typography
              variant="h6"
              sx={{
                fontSize: "16px",
                fontWeight: 700,
                color: "#7C3AED",
                lineHeight: 1,
              }}
            >
              ${message?.orderId?.totalAmount}
            </Typography>
          </Box>
        </Box>
      </Box>

      {message?.orderId?.status == "draft" && (
        <Box
          sx={{
            backgroundColor: "#dc2626",
            color: "#FFFFFF",
            padding: theme?.spacing ? theme.spacing(1.5, 2) : "12px 16px",
            borderRadius: theme?.spacing ? theme.spacing(1) : "8px",
            border: "2px solid #dc2626",
            marginTop: theme?.spacing ? theme.spacing(0.5) : "4px",
          }}
        >
          <Typography
            variant="body2"
            sx={{
              fontSize: "13px",
              fontWeight: 400,
              lineHeight: 1.4,
              color: "#FFFFFF",
              textTransform: "lowercase",
            }}
          >
            {message?.description ||
              "the restaurant order queue is at capacity. please try again later or contact them directly."}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default OrderMessage;
